module.exports = __webpack_public_path__ + "static/media/OAO-Page-Banner.b051da18.png";